import * as React from 'react';
import GamePageLayout from '../../../components/GamePageLayout';
import {navigate} from "gatsby-link";
import {useDispatch, useSelector} from "react-redux";
import {persist} from "../../../redux/actions";
import GameHeader from "../../../components/GameHeader";
import appService from '../../../Service'
import {useEffect, useState , useRef} from "react";
import {closeDialog,showErrorDialog , Button,showLoading,Util,showPlainDialog} from 'baziigram'
import './styles.css'
import {CHAT_ACTION_PERSIST , CHAT_ACTION_CLEAR} from "../../../redux/Chat/chat.constant.js"
import {init  } from "../../../Handlers/Group"
import {sendMessageToGroup,requestToSync , syncMessages} from "../../../Handlers/Group"
import {GetUser , UpdateUser} from "../../../Util/user"
import {dictionary} from "../../../constants"
const ChatPage = (props) => {

const[encKey,_setEncKey] = useState(null)
const[decryptedChats,_setDecryptedChats] = useState([])
const[syncCounter,_setSyncCounter] = useState(0)

const {  chats , newMessage , group , gameId , user , chatId , pageNumber , pageSize ,
 isConnected , inProgress  , language , chatsIsSynced} = useSelector(state =>  state.chat);
const maxLength = 50
const encKeyRef = React.useRef(encKey);
const decryptedChatsRef = React.useRef(decryptedChats);
const syncCounterRef = React.useRef(syncCounter);
const firstUpdate = useRef(true);

const setEncKey = data =>{
encKeyRef.current = data;
_setEncKey(data)
}



const setDecryptedChats = data =>{
decryptedChatsRef.current = data;
_setDecryptedChats(data)
}

const setSyncCounter = data =>{
syncCounterRef.current = data;
_setSyncCounter(data)
}


  const dispatch = useDispatch();
  const updateState=(state)=>{
    dispatch(persist(state, CHAT_ACTION_PERSIST))

  }



  React.useEffect( ()=>{
  let locationState = {}
   if(props.location && props.location.state && props.location.state.gameId)
   {const {gameId , group} = props.location.state
   let chatObj = {}
   let id = group.name+"-"+gameId
   if(!chats[id])
   {chatObj[id]={}
   chatObj[id]["messages"]=[]
   chatObj[id]["lastUpdate"]=0
   }
   else
   chatObj =  chats
   locationState = {gameId:props.location.state.gameId , group:props.location.state.group , chats:chatObj ,chatId:id
    }
   }

   updateState(Object.assign({},{user:GetUser() , pageNumber:1 ,  newMessage:"" , isConnected:0 , inProgress:false ,
    language:Util.getLanguage() , chatsIsSynced:false},locationState))
    setDecryptedChats([])
    init(gameId,(connected)=>{ updateState({isConnected:connected})});

  },[])


React.useEffect(()=>{
 if(user && group && encKey==null)
    {
    if(isConnected==1 && group.connected>1 && !user[chatId])
    { requestToSync(group.name , gameId , getKeyFromServer)
      setTimeout(()=>{
      if(encKey==null) getKeyFromServer()},3000)
      }

    else if(firstUpdate.current==true)
     {setKey()
     firstUpdate.current = false;
     }
     }

  },[user , group , isConnected , encKey ])

React.useEffect(()=>{
    if(encKey != null && chatsIsSynced==false){
    firstUpdate.current = true;
     if(group && group.connected>1)
     syncMessages( chats[chatId].messages , chats[chatId].lastUpdate)

     else
       {
     setDecryptedChats([])
     setTimeout(()=>loadMessagesFromServer(false),500)
        }
      }
  },[encKey])

React.useEffect(()=>{
    if(chats[chatId] && chats[chatId].messages && encKey!=null && decryptedChats.length==0)
    loadMessages()

  },[chats , decryptedChats])


const getKeyFromServer=()=>{
setDecryptedChats([])
 setTimeout(()=>loadMessagesFromServer(true),500)
}

 const setKey=(key=null)=>{
 key = key || user[chatId]
 Util.Crypto.unwrapKey(key , chatId).then(res=> {
     setEncKey(res)
     }).catch(err=>{
     getKeyFromServer()
     })
 }

 const loadMessages= async ()=>{
 for(var i=0 ; i<chats[chatId].messages.length ; i++){
 try{
      let chat = await  Util.Crypto.decrypt(encKeyRef.current , chats[chatId].messages[i])
      if(chat == null)
        {
        setDecryptedChats([])
        setEncKey(null)
        break
        }
       let decrypted= JSON.parse(JSON.parse(chat))
         if(decrypted.sender && decrypted.sender.name == user.userName && decrypted.sender.cId == group.cId)
           decrypted.tag = "me"

           else
           decrypted.tag = "others"
        let list = decryptedChatsRef.current.concat([decrypted])
        setDecryptedChats(list)
        } catch{
         setDecryptedChats([])
         setEncKey(null)
         break
        }
   }
 }

 const loadMessagesFromServer=(offline)=>{
   showLoading(true)
    appService.GetChats(group.name , gameId , pageNumber , maxLength , offline).then(res=>{
    if(offline==true)
    {
    user[chatId]=res.list.splice(0,1)[0]
      UpdateUser(user)
      updateState({user:GetUser()})
      setKey(res.list.splice(0,1)[0])
     }
    chats[chatId] = {messages:res.list , lastUpdate: new Date().getTime()}
   setTimeout(()=>updateState({chats:JSON.parse(JSON.stringify(chats)) , pageNumber:res.list.length>=pageSize ? pageNumber+1 : pageNumber,
     chatsIsSynced:true}),500)
   }).catch(err=>{
      let action = {title:dictionary.retry[language],
       onClick:()=>{closeDialog();loadMessagesFromServer(offline);}
       }
       let msg = <p className="text-danger">{err.message || err}</p>
        let title = <p className="text-danger">{dictionary.error[language]}</p>
       showPlainDialog(msg, title , null , action)
    }).finally(res=>{
    showLoading(false)
    })
  }

  useEffect(() => {

    window.addEventListener('receiveMessage',receiveMessage)
    window.addEventListener('successfulSending',reset)
    window.addEventListener('syncMessages',receiveSyncedMessages)
    window.addEventListener('sync',resetUser)
    window.addEventListener('connectToHub',setGroup)
    return () => {
      window.removeEventListener('receiveMessage',receiveMessage)
      window.removeEventListener('successfulSending',reset)
      window.removeEventListener('syncMessages',receiveSyncedMessages)
      window.addEventListener('sync',resetUser)
      window.removeEventListener('connectToHub',setGroup)
      };
  }, []);

const setGroup = (e)=>{
if(e.detail && e.detail.name)
updateState({group:{...group,...e.detail}})

else
updateState({group:null})
}

const resetUser=()=>{
 updateState({user:GetUser()})
}

const receiveSyncedMessages=(e)=>{
if(e.detail && e.detail.messages &&  e.detail.lastUpdate > chats[chatId].lastUpdate)
{
chats[chatId] = {messages:e.detail.messages , lastUpdate:e.detail.lastUpdate}
   updateState({chats:Object.assign({},chats) , chatsIsSynced:true})
   if(syncCounterRef.current+1!=group.connected)
    setSyncCounter(syncCounterRef.current+1)
}

else if(e.detail.lastUpdate==0 && chats[chatId].lastUpdate>0)
 syncMessages( chats[chatId].messages , chats[chatId].lastUpdate)


}


const receiveMessage =  (e)=>{
if(e.detail && e.detail.message )
{
  Util.Crypto.decrypt(encKeyRef.current , e.detail.message).then(res=>{
  if(res==null)
    {
    setDecryptedChats([])
    setEncKey(null)
     return
    }

  let decrypted = JSON.parse(JSON.parse(res))
  if(chats[chatId].messages.length>=maxLength)
  chats[chatId].messages.splice(0,chats[chatId].messages.length-maxLength)
  if(decrypted.sender && decrypted.sender.name == user.userName && decrypted.sender.cId == group.cId)
  decrypted.tag = "me"

  else
  decrypted.tag = "others"

  let list = chats[chatId].messages.concat([e.detail.message])
  setDecryptedChats(decryptedChatsRef.current.concat([decrypted]))
  chats[chatId]= {messages:list , lastUpdate:decrypted.time}

  updateState({chats:Object.assign({},chats)})
  scrollToBottom()
  }).catch(err=>{
     setDecryptedChats([])
     setEncKey(null)
  })
}

}


const reset=()=>{
updateState({newMessage:"" , inProgress:false})

}



const send = async ()=>{
if(newMessage=="" || isConnected!=1)
return


let message = {time:new Date().getTime() ,
message : newMessage ,
sender : {name:user.userName , logo:user.logo , cId:group.cId},
}

let encMsg = await Util.Crypto.encrypt(encKeyRef.current , JSON.stringify(message))
if(encMsg==null)
 {
 setDecryptedChats([])
 setEncKey(null)
  return
 }

sendMessageToGroup(encMsg , group.name , gameId , ()=>{updateState({inProgress:false})})
updateState({inProgress:true})
}

const scrollToBottom = () => {
    const element = document.getElementById("chats");
    element.scrollTop = element.scrollHeight;
}



  return (
      <GamePageLayout type={CHAT_ACTION_CLEAR} >
      <div  className={"px-3 py-2 rtl"}  >
     <div className="top-menu d-flex flex-row rtl align-items-center">
          {group  && <> <img className="ml-2" height="75px" width="60px" src={`/images/Group/flags/${group.flag}.png`}/>
              <p style={{display:"inherit"}} className={`flex-fill text-right m-0 ${language=="fa" ? "rtl" : "ltr"}`}> <span className="online-users"> </span> {group.connected} {dictionary.onlinePersons[language]}  </p>
                </>}
      <button onClick={()=>navigate("/Game/LifeStone",true)}><img className="life-stone-btn" src="/images/icons/backBtn.png"/></button>
           </div>
           {group && <p  className="text-right w-100 mb-0">{group.name}</p>}
           </div>

   {encKey!=null && <div  className="w-100 bottom-menu d-flex flex-row justify-content-center py-2 ">
   {inProgress && <div className={`baziigramFSpinner mt-5 spinner-border text-light m-auto`}></div>}
     {inProgress == false && <><textarea value={newMessage} onChange={(e)=>updateState({newMessage:e.target.value})}
     className={`mx-1 chat-input  flex-fill ${language=="fa" ? "rtl" : "ltr"}`} >

        </textarea>
    {decryptedChatsRef && decryptedChatsRef.current && <button  onClick={send}><img className="life-stone-btn" src="/images/icons/send.png"/></button>}
  </>}
   </div>}
        <div  className={"life-stone-container"} style={{overflow:"hidden" , height:"calc(100% - 130px)" , height:"-webkit-calc(100% - 130px)"}}>
        <div id={"chats"} className="ltr" style={{overflow:"auto" , height:"calc(100% - 55px)" , height:"-webkit-calc(100% - 55px)"}}>
         <GameHeader>
        <div className={"text_header text-center d-flex flex-column justify-content-center align-items-center"}>
            <div dangerouslySetInnerHTML={{__html: dictionary.chatHeader[language]}} />
           <Button onClick={scrollToBottom} title={dictionary.viewChats[language]}></Button>
         </div>
         </GameHeader>

          <div  className='main_container'>
            {encKey==null && group && <div className={"text-center text-warning mt-5"}>
               {dictionary.retryText[language]}
            <Button onClick={getKeyFromServer} className={"mt-3"} title={dictionary.retry[language]}/>
             </div>}
             {encKey==null && group==null && <div className={"text-center  mt-5"}>
              {dictionary.connecting[language]}
              <br/><br/>
              <div className={`baziigram-spinner mt-5 spinner-border text-light m-auto mt-3`} role="status" ></div>
               </div>}
            { encKey != null &&
           decryptedChatsRef &&  decryptedChatsRef.current && decryptedChatsRef.current.map((chat,i)=>{

           if(!chat.sender)
              return <div className={`px-2 d-flex flex-row justify-content-center  rtl`}>
                           <div className={`text-right flex-fill server-chat-dialog`}>
                          {chat.message}</div>
                          </div>
           else
            return <div className={`px-2 d-flex flex-row justify-content-between align-items-end ${chat.tag == "me"?"rtl":"ltr"}`}>
            <img  width={"30px"} height={"30px"} className={"mb-2"} src={`/images/profileImages/${chat.sender.logo}.png`}/>
             <div className={`text-right flex-fill ${chat.tag=="me" ? "my-chat-dialog" :"other-chat-dialog" }`}>
            <div className="chat-sender  mb-3 mx-2">{chat.sender.name}</div>
            {chat.message}</div>
            </div>
            })
            }
            <div className="grid-container rtl mb-0">



            </div>

             </div>
          </div>


        </div>

      </GamePageLayout>
  )
}

export default ChatPage;
